import Routes from './routes';
var assetdata;
var locationdata;
var locationfilters;
var serviceEventDropdowns;
var rules;
var assetIdentityTypes;


const ClearAllCodes = async function () {
    assetdata = undefined;
    locationdata = undefined;
    locationfilters = undefined;
    serviceEventDropdowns = undefined;
    rules = undefined;
}

const GetLocationCodes = async function () {

    if (locationdata == undefined) {

        const response = await fetch(Routes.CodesCache.LocationCodes());
        const data = await response.json();

        locationdata = data;

        // bind translation to dropdown list

        return locationdata;
    }
    else {
        return locationdata;
    }

}

const GetAssetCodes = async function () {

    if (assetdata == undefined) {

        const response = await fetch(Routes.CodesCache.AssetDropdowns());
        const data = await response.json();
        assetdata = data;

        return assetdata;
    }
    else {
        return assetdata;
    }

}

const GetLocationFilters = async () => {
    if (locationfilters == undefined) {

        const response = await fetch(Routes.Location.LocationTableFilters());
        const data = await response.json();

        locationfilters = data;

        return locationfilters;
    }
    else {
        return locationfilters;
    }
};


// TODO : Add service event leak dropdown cache here

const GetServiceEventDropDowns = async () => {
    if (serviceEventDropdowns == undefined || serviceEventDropdowns == null) {
        const reponse = await fetch(Routes.CodesCache.ServiceEventDropdowns());
        const ServiceEventResponse = await reponse.json();

        serviceEventDropdowns = ServiceEventResponse;

        return serviceEventDropdowns;
    }
    else {
        return serviceEventDropdowns;
    }
}

const GetRules = async () => {
    if (rules == undefined || rules == null) {
        const reponse = await fetch(Routes.CodesCache.Rules());
        const RulesResponse = await reponse.json();

        console.log(RulesResponse);

        rules = RulesResponse;

        return rules;
    }
    else {
        return rules;
    }
}

const GethAssetIdentityTypes = async () => {
    const response = await fetch(Routes.CodesCache.AssetIdentityType());
    const data = await response.json();

    if (response.status === 200) {
        const newOptions = data.map(({ id, name }) => ({
            id,
            name
        }))

        assetIdentityTypes = newOptions;
        return newOptions;
    }

    return [];
}

export { ClearAllCodes, GetLocationCodes, GetLocationFilters, GetServiceEventDropDowns, GetRules, GetAssetCodes, GethAssetIdentityTypes };